import { useState, useEffect, useCallback } from 'react';
import { PaymentDTO } from '../types';
import HttpClientRequest from '../api/client-request';
import PaymentService from '../services/payment-service';

export const usePayment = () => {
  const [payment, setPayment] = useState<PaymentDTO|undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const requestId = new Date().getTime().toString();

  const verifyPayment = useCallback(async (txRef: string) => {

    try {
      
      setLoading(true);
      
      const { status, data, message } =  await PaymentService.verifyPayment(txRef, requestId);
      
      if (status !== 200) {
        setError(message);
        return ;
      }

      setPayment(data);
      
    } catch (error) {
      setError((error as Error).message);
    }
    finally {
      setLoading(false);
    }

  }, [requestId])

  useEffect(() => {

    return () => {
      
      HttpClientRequest.cancelRequest(requestId); // Cancel the request if needed

      setPayment(undefined);
      setLoading(false);
      setError(null);
    }
  }, []);

  return { payment, verifyPayment, loading, error };
};